import React from "react";
import "./style.scss";

const Loader = () => {

    return (
        <div className={'loader'}>
            <div className={'loader__content'}/>
        </div>
    )
}

export default Loader;
